// extracted by mini-css-extract-plugin
export var feelingHungryButton = "footer-module--feelingHungryButton--v48QV";
export var feelingHungrySection = "footer-module--feelingHungrySection--NHnU7";
export var footerLocationsSection = "footer-module--footerLocationsSection--0-qnX";
export var footerNavSection = "footer-module--footerNavSection--VB1PT";